export default __webpack_public_path__ + "static/media/Business-Premium.4a79ccfd.svg";